import { TAttachmentDTOCamelCased } from '../model/types';

/**
 * хелпер проверяет, является ли прикрепленный файл присланным с сервера, т.е. DTO-шкой
 * и соответственно файлом со структурой TAttachmentDTO
 * @param obj - принимает структуру аттачмента
 */

export function isAttachmentDTO(obj: unknown): obj is TAttachmentDTOCamelCased {
    return !!obj && typeof obj === 'object' && ('original_url' in obj || 'originalUrl' in obj);
}
